import React from "react";
import { classNames } from "../../shared/utility";
import { InputNumber } from "primereact/inputnumber";

export default function DollarInputText(props) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    type,
    value,
    labelOn,
    error,
    suffix,
    explanation,
    ref,
    labelClass,
    ...other
  } = props;

  // PrimeReact InputNumber uses onValueChange({ value }) — useForm expects e.target.name/value
  const handleValueChange = (e) => {
    if (!onChange) return;
    const raw = e?.value;
    onChange({
      target: {
        name,
        value: raw === null || raw === undefined ? "" : raw,
      },
    });
  };

  return (
    <div className={parentClass ? parentClass : null}>
      {labelOn ? (
        <label
          htmlFor={name}
          className={classNames(
            labelClass ? labelClass : "text-sm",
            "block font-medium text-gray-900 mb-2"
          )}
        >
          {label}
        </label>
      ) : null}
      <div>
        <InputNumber
          name={name}
          className={classNames(className, "w-full")}
          value={value}
          onValueChange={handleValueChange}
          mode="currency"
          currency="USD"
          locale="en-US"
          onKeyDown={(e) => e.stopPropagation()}
          ref={ref}
          suffix={suffix}
          {...other}
        />

        {error ? <p className="font-medium text-red-500 mt-1 text-sm">{error}</p> : null}
      </div>
    </div>
  );
}
